import { render, staticRenderFns } from "./ZoneChairmanAssignSeniorMember.vue?vue&type=template&id=40d3648c"
import script from "./ZoneChairmanAssignSeniorMember.vue?vue&type=script&lang=js"
export * from "./ZoneChairmanAssignSeniorMember.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports